export default {
  layoutView: {
    headSearchPlaceholder: "请输入搜索内容",
    login: "登录",
    register: "注册",
    lxwm: "联系我们",
    bq1: "西安金融控股有限公司 版权所有 @2020, www.rmbsilkroad.cn Inc.",
    bq2: "陕ICP备17009375号-3",
    bq3: "增值电信业务经营许可证: 陕B2-20220236",
  },
  // 首页
  homeView: {
    title1: "平台介绍",
    title2: "金融服务",
    title3: "产品展示",
    title4: "跨境资讯",
    title5: "友情链接",
    more:"更多",
    PlatformDescription:
      '“通丝路”跨境贸易数字化综合服务平台是由中国人民银行陕西省分行的指导和中国（陕西）自由贸易试验区政策的支持，由西安金融控股有限公司负责建设运营，“通丝路”跨境贸易数字化综合服务平台由“通丝路”跨境电商人民币结算服务平台及通丝路外贸综合服务平台组成，旨在支持陕西自贸区和“一带一路”建设，倡导跨境人民币结算，探索内陆与“一带一路”沿线国家经济合作与交流的新模式。',
    Kjds: "跨境电商",
    Kjrmb: "跨境人民币",
    Wmzh: "外贸综合",
    ptbg: "报关",
    ptbj: "报检",
    ptsjh: "收结汇",
    ptbsts: "办税/退税",
    pthwc: "海外仓",
    ptbx: "保险",
    ptwl: "物流",
    ptjr: "金融服务",
    jrfw0: "退税融资",
    jrfw1: "订单融资",
    jrfw2: "备货融资",
    jrfw3: "锁汇易",
    jrfw4: "信保服务",
    jrfwdesc0: "单证齐全3个工作日可拿到退税款",
    jrfwdesc1: "赊销/信用证订单 为您单笔最高提前垫付80%应收款",
    jrfwdesc2: "买家账期太长 周转吃力 不如提前回款 让您外贸生意做大做强！",
    jrfwdesc3: "免费在线锁定未来到账外汇的结汇汇率 规避订单波动风险，保障外贸订单收入 不再为汇率波动烦心",
    jrfwdesc4: "全面资信调查 保障资金和账户安全 代办所有手续 简单方便 赔付率最高80%",
  },
  // 报关服务
  bgfwView: {
    title: "报关服务",
    title1: "服务介绍",
    title2: "服务流程",
    ServiceIntroduction: "多年行业经验代为办理结关、海关证明联等手续，以及配合海关对进出口货物的査验等服务，提高报关效率，帮助客户避免报关错误，缩短报关时间，专业跟单预审报关资料，做到一次过单成功，并可协助商检查验，做到出现问题及时处理，避免不必要的延误导致的费用，让您省时!省心!更省钱!",
    flow1: "01.申请服务",
    flow2: "02.申报",
    flow3: "03.查验",
    flow4: "04.海关放行",
    flow5: "05.结算",
  },
  // 金融服务
  jrfwView: {
    title: "金融服务",
    title1: "服务内容",
    title2: "服务优势",
    title3: "融资服务",
    bannerdec: "解决企业融资困难，降低融资成本",
    desc1: "破解中小企业因规模小、财务数据不全等原因难以取得银行直接融资或融资成本高的困局，为入驻企业提供供应链融资、保险、支付、代办退税等服务。",
    flow1: "代办保险",
    flow2: "推动企业融资",
    flow3: "金融机构数据对接",
    flow4: "一站式简易操作平台",
    fwys1: "专",
    fwys2: "安",
    fwys3: "信",
    fwys4: "规",
    fwysTitle1: "服务规范",
    fwysTitle2: "信息安全",
    fwysTitle3: "轻松对接",
    fwysTitle4: "利率透明",
    fwysDesc1: "国有平台，定制产品，专业顾问全流程服务",
    fwysDesc2: "企业个人数据脱敏存档，专属服务器，无泄漏隐患",
    fwysDesc3: "多家金融机构合作，客户选择范围广",
    fwysDesc4: "正规金融机构，利率透明，无中介手续费",
    rzTitle1: "退税融资",
    rzTitle2: "订单融资",
    rzTitle3: "备货融资",
    rzTitle4: "锁汇易",
    rzDesc1: "通丝路平台达针对中小企业退税难退税慢所推出的一项金融服务， 使用该服务只需要满足3个条件： 全额外汇款收到、开正确增值税发票、收到报关单退税联原件（若您自行安排报关）。条件满足后，通丝路平台会在3个工作日内即向您支付退税款。",
    rzDesc2: "为支持国际货物贸易项下出口商和国内货物贸易项下中小企业备货出运，应企业的申请,根据其提交的销售合同或订单（以下统称“订单”）向其提供用于订单项下货物采购的专项贸易融资。",
    rzDesc3: "基于中小企业与海外买家的真实贸易背景，以企业提供的外贸订单为保障的一项低息短期贷款服务。此项金融服务会帮助出口商解决备货期间的生产、采购资金需求，提升企业接单能力。",
    rzDesc4: " 免费在线锁定未来到账外汇的结汇汇率 规避订单波动风险，保障外贸订单收入。 单波动风免费在线锁定未单波动风来到账外汇的结汇汇率 规避订单单波动风波 免费在线锁定未来到账外汇的结汇汇率 规避订单波动风险，保障外贸订单收入。不再为费率烦心！",
    rzDesc5: "产品功能：满足中小企业融资需求，帮助企业扩大贸易机会，减少资金占用。",
    rzDesc6: "适用客户：备货阶段有融资需求的中小企业。",
    fontTitle1: "垫付100%",
    fontTitle2: "最快3天",
    fontTitle3: "超低费率",
    fontTitle4: "无抵押",
    fontTitle5: "无担保",
    fontTitle6: "门槛低",
    shtitle1: "签订委托协议",
    shtitle2: "受委托锁汇",
    shtitle3: "通过平台进/出口",
    shtitle4: "外汇交割期内付款",
    shtitle5: "进/出口业务结算",
    rzIconTitle1: "资质宽",
    rzIconTitle2: "小额纳税人也可以退款",
    rzIconTitle3: "速度快",
    rzIconTitle4: "最快3日到款",
    rzIconTitle5: "操作简便",
    rzIconTitle6: "合规办理，安全顺畅",
    rzIconTitle7: "接单开源",
    rzIconTitle8: "接赊销订单",
    rzIconTitle9: "买断风险",
    rzIconTitle10: "最高买断80%应收账款",
    rzIconTitle11: "快速融资",
    rzIconTitle12: "发货后3个工作日内融资款到账",
  },
  // 跨境电商
  kjdsView: {
    title: "9710出口",
    title1: "服务介绍",
    title2: "跨境人民币结算的服务优势",
    bannerdec: "跨境贸易电子商务",
    desc1: 
    '“通丝路”跨境电商人民币结算服务平台为国内供应商、跨境卖家、海外消费者提供涵盖跨境贸易全流程的数字化服务体系。通过整合国内供应商资源，为跨境卖家提供智能选品平台，实现高效选品开店。通丝路B2B跨境电商人民币结算服务平台，全程使用人民币计价支付，为海外卖家提供产品展示、跨境贸易撮合、交易订单生产、贸易融资等线上服务，帮助企业减少汇兑损失，降低开店成本，高效开拓外贸大市场。同时链接其他海外跨境电商等销售渠道资源，为跨境卖家提供独立站建站服务，通过智能数字获客、社交媒体推广，实现精准营销，从而推动我国的品牌通过跨境卖家实现出海，同时构建起跨境人民币应用的新场景。',
    flow1: "报关",
    flow2: "收结汇",
    flow3: "退税",
    flow4: "仓储/物流",
    flow5: "信用保险",
    flow6: "报检",
    flowDesc1: "根据客户业务需求，提供9710出口业务清单模式和报关单模式报关服务代理申报，系统直连海关，无需企业与通关服务平台对接，省事省力。",
    flowDesc2: "降低汇率风险",
    flowDesc3: "节省汇兑成本",
    flowDesc4: "提高结算效率",
    flowDesc5: "增强交易安全性",
    flowDesc6: "一步到位，拒绝繁琐",
    flowDesc7: "阳光透明，合法合规",
    flowDesc8: "便捷退税，降本增效",
    flowDesc9: "跨境电商头程服务",
    flowDesc10: "整箱，拼箱服务",
    flowDesc11: "空运、快件服务",
    flowDesc12: "海外仓服务：一件代发，退换货服务",
    flowDesc13: "交易保障更放心：全面客户资信调查，保障交易安全",
    flowDesc14: "投保理赔更省心：代办所有手续，简单方便，出险赔付无忧",
    flowDesc15: "提供检验检疫/原产地证办理等",
    fwysTitle1: "降低汇率风险",
    fwysTitle2: "节省汇兑成本",
    fwysTitle3: "提高结算效率",
    fwysTitle4: "增强交易安全性",
    fwysDesc1: "通过使用人民币进行跨境结算，企业可以减少因汇率波动带来的风险，从而更好地控制成本和预测收益。",
    fwysDesc2: "跨境人民币结算减少了货币兑换的需求，从而降低了汇兑费用和相关成本。",
    fwysDesc3: "使用人民币结算可以简化结算流程，加快资金到账速度，提高整体的交易效率。",
    fwysDesc4: "跨境人民币结算有助于提高交易的安全性，减少欺诈和错误的风险。",
  },
  //外贸综合
  wmzhView: {
    title: "外贸综合",
    title1: "报关报检",
    title2: "外汇收付",
    title3: "代办退税",
    title4: "物流仓储",
    title5: "中信保",
    title6: "中欧班列",
    desc1: "通过智能纠错与风险预警功能，平台能够提前识别潜在问题，避免风险发生，确保通关流程顺畅、无忧。支持批量申报功能，快速发送报关信息，实现全国通关，数据自动回传，简化流程，节省时间。提供全过程可视化进度追踪，让您随时掌握报关报检的每个环节，节点清晰透明，确保进度一目了然。清关程序完全透明且符合法规，确保阳光合规操作，让企业在复杂的跨境贸易中放心运行。",
    fontTitle1: "风险管控",
    fontTitle2: "一键申报",
    fontTitle3: "全程可视",
    fontTitle4: "阳光清关",
    fontTitle5: "代理收汇",
    fontTitle6: "代理付汇",
    fontTitle7: "代理开证",
    fontTitle8: "代理收证",
    fontTitle9: "高效退税",
    fontTitle10: "便捷退税",
    wljs: "公司拥有覆盖全球的物流仓储网络，能够为客户提供从国内到海外的高效跨境物流服务。拥有现代化仓库管理系统，采用先进的存储技术、自动化设备，确保货物的安全存储和高效管理。通过与国际顶尖物流公司合作，提供全球快递、海运、空运等多种配送方式，确保快速、安全的货物运输。",
    wlTitle1: "减少物流成本",
    wlTitle2: "提升发货效率",
    wlTitle3: "货物追踪",
    wlTitle4: "一站式服务",
    wlDesc1: "优化供应链 降低物流成本",
    wlDesc2: "智能化管理  缩短发货周期",
    wlDesc3: "实时追踪货物运输状态",
    wlDesc4: "全程一体化服务",
    fontDesc1: "智能纠错 风险预警",
    fontDesc1_1: "",
    fontDesc2: "批量发送 数据回传",
    fontDesc2_1: "",
    fontDesc3: "报关进度 全程跟踪",
    fontDesc3_1: "",
    fontDesc4: "清关程序 阳光合规",
    fontDesc4_1: "",
    fontDesc5: "设立出口货物多币种在线收汇通道 享受优势结汇利率",
    fontDesc5_1: "",
    fontDesc6: "设立进口货物多币种在线付汇通道 享受优势购汇利率",
    fontDesc6_1: "",
    fontDesc7: "提供代理开设信用证服务 弥补进口企业授信不足缺口",
    fontDesc8: "提供代收信用证服务 降低出口企业跨境结算风险",
    fontDesc9: "合规报批 安全通畅 单证齐全最快3个工作日到款 不限金额 不限单数",
    fontDesc10: "丰富的退税经验 为客户提供专业的服务体验",
    fwysDesc1: "跨境物流对时效、成本、安全等要求高。平台通过与业内优质高效的物流公司合作，为跨境电商企业和个人卖家提供全球端到端物流解决方案，实现从卖家到客户一站式物流可视化跟踪管理，帮助电商客户管理物流供应。平台与行业主流跨境电商海外运营商实现系统对接，可提供海外仓一件代发、FBA中转仓分发服务。",
    fwysDesc2: "可以根据货物的性质和运输距离，选择最经济、最快捷的运输方式，从而降低物流成本。通过多式联运，货物可以在不同的运输方式之间无缝连接，从而缩短物流时间，提高物流效率。可以避免货物在转运过程中频繁装卸，减少货物损坏和丢失的风，提高货物安全性。可以根据货物的特性和运输要求，选择不同的运输方式，从而增强物流灵活性，满足客户的个性化需求。",
    fwysDesc3: "卖家可以实时了解订单的物流状态，包括订单的发货、报关、运输、落地清关、派送等环节，及时掌握订单履约交付进展情况，为客户提供更好的服务。可以帮助卖家及时发现物流问题，并采取有效的措施进行解决，避免物流问题的出现，从而提高订单的物流效率。通过优化物流流程，卖家可以更快地处理订单，减少订单滞留时间，提高订单处理速度。卖家可以实时了解订单的物流状态，及时处理问题，提高客户满意度。同时，卖家还可以根据客户的需求，选择适合的物流方式，提供更好的物流服务，从而增强客户的忠诚度。",
    fwysDesc4: "中国出口信用保险公司是由国家出资设立、支持中国对外经济贸易发展与合作、具有独立法人地位的国有政策性保险公司于2001年12月18日正式挂牌运营，服务网络覆盖全国。",
    fwysDesc5: "中国信保通过为对外贸易和对外投资合作提供保险等服务，促进对外经济贸易发展，重点支持货物、技术和服务等出口，特别是高科技、附加值大的机电产品等资本性货物出口，促进经济增长、就业与国际收支平衡。主要产品及服务包括:中长期出口信用保险、海外投资保险、短期出口信用保险、国内信用保险、与出口信用保险相关的信用担保和再保险、应收账款管理、商账追收、信息咨询等出口信用保险服务。",
    fwysDesc6: "中国信保以“履行政策性职能，服务高水平开放”为己任，有效服务国家战略，精准支持企业发展，确保财务可持续，积极扩大出口信用保险覆盖面，在服务共建 “一带一路”、全力促进外贸稳中提质、培育国际经济合作和竞争新优势、推动经济结构优化等方面发挥了不可替代的作用。",
    xbgntitle1: "信保功能",
    xbgntitle2: "风险分析师",
    xbgntitle3: "买方信用风险筛选",
    xbgntitle4: "提前防范不良买家",
    xbgntitle5: "风险分担者",
    xbgntitle6: "发生风险助力追讨",
    xbgntitle7: "确认债权分担损失",
    xbgntitle8: "竞争好帮手",
    xbgntitle9: "灵活结算订单账期",
    xbgntitle10: "抢占目标市场份额",
    xbgntitle11: "融资助推器",
    xbgntitle12: "激活企业应收账款",
    xbgntitle13: "提高资金使用效率",
    lpyd1: "理赔要点",
    lpyd2: "赔付",
    lpyd3: "关键因素",
    lpyd4: "正确履行商务合同",
    lpyd5: "有效限额(投保成功)",
    lpyd6: "对买方确立债权",
    lpyd7: "保险合同履约无瑕疵",
    zyyd1: "注意要点",
    zyyd2: "保留并提供索赔资料，一般包括:保险单证、贸易单证(提单、报关单、发票、合同)、重要往来函电等",
    zyyd3: "避免已知风险出运。风险异动，请及时与服务商联系",
    zyyd4: "货物出运后，未经信保公司书面同意，不能擅自答应买家的降价、延期付款、变更销售合同的支付方式等要求",
    zyyd5: "正确履行商务合同，包括但不限于定金、交货要求等约定",
    mztk1: "关于“除外责任”、“免责条款”",
    mztk2: "限额申请有误(投保客户对象错误)",
    mztk3: "无法对限额买方确立债权",
    mztk4: "汇率损失",
    mztk5: "被保险人(或其他代理人)违约、欺诈、违法",
    mztk6: "已知风险投保、买家预期违约或根本违约",
    mztk7: "其他保险应保风险，如海运险",
    mztk8: "买方的代理人风险",
    mztk9: "银行擅自放单或船公司擅自放货",
    mztk10: "关联交易",
    mztk11: "信用证结算方式下单证不符",
    mztk12: "特别提醒",
    mztk13: "小额投保模式下以下国家不适用: 韩鲜、委内瑞拉、安哥拉、古巴、伊朗、苏丹、南苏丹、利比亚、科特迪瓦、也门、叙利亚、阿富汗、伊拉克、索马里、布隆迪、乍得、科摩罗、刚果民主共和国.厄立特里亚、几内亚比绍、利比里亚、卢旺达、塞拉利昂、 津巴布韦、巴勒斯坦等国家或地区。",
    hzlcTitle1: "合作流程",
    hzlcTitle2: "线上线下的服务，让我们的合作更加轻松快捷",
    hzlc1: "资质审核",
    hzlc2: "合作签约",
    hzlc3: "在线下单",
    hzlc4: "通关",
    hzlc5: "外汇",
    hzlc6: "退税",
    hzlc7: "结算",
    zoTitle1: "运踪查询",
    zoTitle2: "运营线路",
    zoTitle3: "配套服务",
    zoTitle4: "新闻资讯",
    xlTitle1: "西安——欧洲",
    xlTitle2: "西安——中亚 南亚 西亚",
    xlTitle3: "西安——中白俄",
    xlTitle4: "西安——跨两海通道",
    xlTitle5: "西安——宁波",
    xlTitle6: "西安——青岛",
    xlDesc1: "曼海姆、布拉格、斯瓦夫库夫、帝尔堡、纽伦堡、米兰、伊明汉姆",
    xlDesc2: "乌兹别克斯坦、哈萨克斯坦、吉尔吉斯斯坦、尼泊尔、伊斯坦布尔",
    xlDesc3: "俄罗斯、白俄罗斯",
    xlDesc4: "阿塞拜疆，格鲁吉亚",
    xlDesc5: "（北仑港、宁波北）",
    xlDesc6: "（黄岛港、胶州）",
    xlType1: "中欧班列",
    xlType2: "海铁联运",
    xlType3: "+西欧",
    xlType4: "热门线路",
    jxoTitle1: "延西欧",
    jxoTitle2: "中欧班列宝鸡",
    jxoTitle3: "安西欧",
    jxoTitle4: "临西欧",
    jxoTitle5: "+西欧",
    jxoTitle6: "宿西欧",
    emxlTitle1: "俄罗斯、白俄罗斯班列",
    emxlTitle2: "跨里海、黑海班列",
    emxlTitle3: "中亚回程公共班列",
    emxlTitle4: "俄罗斯回程公共班列",
    rmxlBase1: "西安——俄罗斯——白俄罗斯",
    rmxlBase2: "西安——康斯坦察——曼海姆",
    rmxlBase3: "塔什干——西安",
    rmxlBase4: "莫斯科——满洲里——西安",
    rmxlBase4_1: "莫斯科——阿拉山口——西安",
    rmxlBase4_2: "莫斯科——满洲里——西安",
    rmxlBqLbel: "班期：",
    rmxlbqDesc1: "满洲里- 2列/周 二连-1列/周",
    rmxlbqDesc1_1: "阿拉山口/霍尔果斯-4列/天",
    rmxlbqDesc2: "1列/周",
    rmxlbqDesc3: "1列/周",
    rmxlbqDesc4: "满洲里- 1列/月 山口-1列/月",
    rmxlDays1: "时效：15天",
    rmxlDays2: "时效：15天",
    ptfwTitle1: "保税仓储",
    ptfwTitle2: "关务服务",
    ptfwTitle3: "配送服务",
    ptfwTitle4: "地接服务",
    ptfwTitle5: "堆存服务",
    ptfwTitle6: "集装箱租赁",
    ptfwTitle7: "单证服务",
    ptfwTitle8: "金融服务",
    ptfwDesc1: "为企业提供投资、政务、物流、贸易、产业等多方面服务",
    ptfwDesc2: "具有粮食、肉类、整车进口口岸，同时为合作企业提供报关等专业服务",
    ptfwDesc3: "为合作企业提供境内外集卡车门点服务",
    ptfwDesc4: "为进站车辆提供方案预审，批复生产作业计划、堆区，发运咨询等服务",
    ptfwDesc5: "提供空箱重箱堆存、装卸、转 运、保管、交接等服务",
    ptfwDesc6: "提供普通集装箱、特种冷藏箱租赁服务",
    ptfwDesc7: "为合作企业提供国际联运的单证服务",
    ptfwDesc8: "为各类客户提供7*24小时全天候、专业化商事法律服务",
  },
  //外贸工具
  wmgjView: {
    tabName1: "HS编码",
    tabName2: "外汇牌价",
    title1: "HS编码查询",
    title2: "热门HS商品编码",
    title3: "HS编码简介",
    title4: "物流仓储",
    fontTitle1: "风险管控",
    fontTitle2: "一键申报",
    fontTitle3: "全程可视",
    fontTitle4: "阳光清关",
    fontTitle5: "代理收汇",
    fontTitle6: "代理付汇",
    fontTitle7: "代理开证",
    fontTitle8: "代理收证",
    fontTitle9: "高效退税",
    fontTitle10: "便捷退税",
    fontDesc1: "智能纠错，风险预警",
    fontDesc2: "批量发送，全国通关，数据自动回传",
    fontDesc3: "报关进度全程跟踪，节点一目了然",
    fontDesc4: "清关程序阳光合规",
    fontDesc5: "设立出口货物多币种在线收汇通道，享受优势结汇利率",
    fontDesc6: "设立进口货物多币种在线付汇通道，享受优势购汇利率。",
    fontDesc7: "提供代理开设信用证服务，弥补进口企业授信不足缺口。",
    fontDesc8: "提供代收信用证服务，降低出口企业跨境结算风险。",
    fontDesc9: "合规报批，安全通畅，单证齐全最快3个工作日到款，不限金额， 不限单数。",
    fontDesc10: "丰富的退税经验，为客户提供专业的服务体验。可随时了解。",
    fwysDesc1: "跨境物流对时效、成本、安全等要求高。平台通过与业内优质高效的物流公司合作，为跨境电商企业和个人卖家提供全球端到端物流解决方案，实现从卖家到客户一站式物流可视化跟踪管理，帮助电商客户管理物流供应。平台与行业主流跨境电商海外运营商实现系统对接，可提供海外仓一件代发、FBA中转仓分发服务。",
    fwysDesc2: "可以根据货物的性质和运输距离，选择最经济、最快捷的运输方式，从而降低物流成本。通过多式联运，货物可以在不同的运输方式之间无缝连接，从而缩短物流时间，提高物流效率。可以避免货物在转运过程中频繁装卸，减少货物损坏和丢失的风，提高货物安全性。可以根据货物的特性和运输要求，选择不同的运输方式，从而增强物流灵活性，满足客户的个性化需求。",
    fwysDesc3: "卖家可以实时了解订单的物流状态，包括订单的发货、报关、运输、落地清关、派送等环节，及时掌握订单履约交付进展情况，为客户提供更好的服务。可以帮助卖家及时发现物流问题，并采取有效的措施进行解决，避免物流问题的出现，从而提高订单的物流效率。通过优化物流流程，卖家可以更快地处理订单，减少订单滞留时间，提高订单处理速度。卖家可以实时了解订单的物流状态，及时处理问题，提高客户满意度。同时，卖家还可以根据客户的需求，选择适合的物流方式，提供更好的物流服务，从而增强客户的忠诚度。",
    fwysDesc4: "中国出口信用保险公司是由国家出资设立、支持中国对外经济贸易发展与合作、具有独立法人地位的国有政策性保险公司于2001年12月18日正式挂牌运营，服务网络覆盖全国。",
    fwysDesc5: "中国信保通过为对外贸易和对外投资合作提供保险等服务，促进对外经济贸易发展，重点支持货物、技术和服务等出口，特别是高科技、附加值大的机电产品等资本性货物出口，促进经济增长、就业与国际收支平衡。主要产品及服务包括:中长期出口信用保险、海外投资保险、短期出口信用保险、国内信用保险、与出口信用保险相关的信用担保和再保险、应收账款管理、商账追收、信息咨询等出口信用保险服务。",
  },
  zxzxView: {
    title1: "平台动态",
    title2: "政策法规",
    title3: "行业态势",
    title4: "通知公告",
    fbsj: "发布时间：",
  },
  stfwView: {
    title1: "生态服务",
    desc1: "“通丝路”跨境贸易数字化综合服务平台创新了“外综服+外贸新业态+跨境人民币结算”的服务模式，与海关、税务、物流、金融、信保等机构建立合作关系并线上系统对接，实现”全链条、一站式“的外贸综合服务平台。以跨境贸易撮合、人民币跨境结算支付、报关报检、退税结算、收汇付汇、金融信保、物流仓储、跨境开店、孵化培训、数字获客、贸易展会、政策解读等为“一带一路”贸易全流程市场化综合服务为基础，构建“企业服务+公共服务+政务服务”三位一体的数字化服务体系，有效促进贸易主体、贸易对象、贸易方式、贸易服务四大方面实现数字化转型，促进内外贸一体化。"
  },
  gywmView: {
    title1: "平台简介",
    title2: "公司简介",
    title3: "平台介绍",
    title4: "公司介绍",
    title5: "业务介绍",
    title6: "未来发展",
    ptjj1: "“通丝路”跨境贸易数字化综合服务平台由西安金融控股有限公司负责建设运营，“通丝路”跨境电商数字化综合服务平台由“通丝路”跨境电商人民币结算服务平台及通丝路外贸综合服务平台组成，旨在支持陕西自贸区和“一带一路”建设，倡导跨境人民币结算，探索内陆与“一带一路”沿线国家经济合作与交流的新模式。",
    // "“通丝路“跨境电商数字化综合服务平台是由中国人民银行陕西省分行的指导和中国（陕西）自由贸易试验区政策的支持，由西安金融控股有限公司负责建设运营，”通丝路“跨境电商数字化综合服务平台由“通丝路”跨境电商人民币结算服务平台及通丝路外贸综合服务平台组成，旨在支持陕西自贸区和“一带一路”建设，倡导跨境人民币结算，探索内陆与“一带一路”沿线国家经济合作与交流的新模式。",
    ptjj2: "“通丝路”跨境电商人民币结算服务平台于2018年4月上线运营，由中国人民银行陕西省分行的指导和中国（陕西）自由贸易试验区政策的支持，是全国首个作为主打跨境电子商务人民币结算的服务平台，为企业提供企业宣传推广、产品信息发布、贸易合同撮合、交易订单生成、在线报关报检、跨境人民币结算申报、国际收支申报、信用担保服务和资金融通服务等多项功能。",
    ptjj3: "“通丝路”外贸综合服务平台致力于为全国中小微出口企业打造一个全方位的服务体系，提供包括但不限于报关报检、物流仓储、退税、收汇结汇、信用保险以及金融服务等多元化的“一站式”服务，助力企业简化出口流程，提升贸易效率。",
    gsjj1: " 西安金融控股有限公司（简称“西安金控公司”），成立于2016年5月，是经西安市人民政府批准，由西安浐灞生态区管委会、西安浐灞发展集团有限公司投资设立的国有企业，注册资本30亿元，发展定位为区域金融产业发展的综合服务商，肩负着区域金融服务和产业投资发展的重任，履行区域产业金融、产业投资、产业服务使命，致力于打造产业投资、金融服务、资本运作平台，以金融化的手段和市场化的措施，推动区域产业繁荣和城市发展。目前已拥有西安浐灞融资担保有限公司、西安浐灞基金管理有限公司、陕西西金融资租赁有限公司、陕西西金商业保理有限公司等子公司；设立了产业投资部，管理运营“通丝路”跨境电商平台等战略投资项目；投资参股了西安银行、陕西环境权交易所有限公司、陕西股权交易中心股份有限公司等区域内知名的金融机构。",
    gsjj2: "西安浐灞基金管理有限公司成立于2016年5月，注册资本5000万元，是西安金融控股有限公司下设的全资子公司。目前运营管理丝路文化产业基金、网络影视基金，充分发挥母基金引导效能，助力区域产业繁荣发展。",
    gsjj3: "西安浐灞融资担保有限公司是西安金融控股有限公司的全资子公司，注册资本15亿元，属陕西省政府性融资担保体系成员，自2011年8月成立以来，始终秉承“政府出资、政策引导、企业化管理、市场化运作”的经营理念，累计为砂之船奥特莱斯、华夏文旅等省、市、区重点招商企业提供融资担保服务超100亿元。",
    gsjj4: "陕西西金融资租赁有限公司是由西安金融控股有限公司、同泽金融控股集团有限公司（港资）等共同出资组建的合资融资租赁公司，公司成立于2018年5月，注册资本10亿元。专注于旅游会展、高端制造、医疗健康、汽车金融等业务板块，致力于成为一家特色鲜明、经营稳健、风控严密、业绩优良的融资租赁公司。荣获陕西省融资租赁行业协会“2021年度追赶超越奖”。",
    gsjj5: "陕西西金商业保理有限公司成立于2018年4月，注册资本1亿元，是西安金融控股有限公司全资子公司。公司秉承专业、创新、协同的发展理念，以助力区域产业与自身发展相结合，业务范围涵盖应收账款融资、应收账款收付结算、销售分户（分类）账管理，以及与本公司业务相关的非商业性坏账担保、客户资信调查与评估、商业保理相关咨询服务。陕西西金商业保理有限公司秉承“专业、创新、协同”的发展理念，以助力区域产业与自身发展相结合，业务板块涵盖公用事业、生态环保、健康医疗、现代教育及商贸物流等行业。",
    gsjj6: "“通丝路”平台全称通丝路跨境电子商务人民币结算服务平台，旨在推动陕西自贸区和“一带一路”建设，支持陕西自贸区实体经济发展，倡导跨境人民币结算，推行人民币国际化战略，以跨境电商的方式将货物进口和出口丝路沿线国家，以跨境电商人民币结算为核心亮点，为企业提供产品展示、企业宣传、在线报关、商检、投保的“一站式”服务的B2B贸易综合服务平台，为陕西省企业走出去搭建一条更加便捷的“人民币网上丝绸之路”。",
    gsjj8: "2023年3月23日，西安金融控股有限公司被授予首批西安市科技金融服务工作站。作为浐灞生态区唯一一家被认定的西安市科技金融服务工作站，西安市科技金融服务工作站（浐灞）将按照市、区有关部署，紧紧围绕“秦创原”平台效应发挥和放大，立足区域资产禀赋，以建设西安综合性科学中心和具有全国影响力的科技创新中心等重点工作为抓手，坚持“服务性定位+市场化运作”，着力整合优势资源，持续健全服务体系，不断拓展服务功能，充分发挥“科技+金融”平台服务作用，大力构建“投、贷、保、担”协同创新金融生态，努力推动区域创新链、产业链、资金链深度融合，助力区域科技创新工作。",
    gsjj10: "未来，金控公司将坚持“金融+孵化+产业”的发展模式，紧紧围绕生态区“1+2+1”现代绿色生产性服务业产业体系，推动产业园开发运营，加大会议会展、文化旅游、现代金融、数字经济等产业投资服务，做强做优做大金融与产业互乘放大效应，深耕“产业投资、产业运营、资产并购、资产经营”四大板块，努力服务区域新兴产业跨越式发展，为助力区域奋力谱写新时代高质量发展新篇章作出应有贡献。",
    gsjjTitle1: "（一）基金业务",
    gsjjTitle2: "（二）担保业务",
    gsjjTitle3: "（三）租赁公司",
    gsjjTitle4: "（四）保理公司",
    gsjjTitle5: "（五）“通丝路”平台",
    gsjjTitle6: "（六）西安市科技金融服务工作站（浐灞）",
  },
  lxwmView: {
    gsmc: "公司名称：西安金融控股有限公司",
    addr: "地址：陕西省西安市浐灞生态区浐灞商务中心二期301室",
    tel: "电话：029-83597719 / 400-108-8899",
    email: "邮箱：service@xajkgroup.com",
    wb: "金控微博",
    wx: "金控微信"
  }
};
